'use client';
import React, { FC } from 'react';
import { Image } from '@/components';
import { ExtendedTypeHomepageHeroFields } from '@/components/common/HomepageHero/HomepageHero';
import { UniversalCta } from '../../UniversalCta';
import { TypeImage } from '@/core/generated-types';
import styles from '../HomepageHero.module.scss';

export const PromoRichText: FC<ExtendedTypeHomepageHeroFields> = ({
  entryName,
  desktopMedia,
  mobileMedia,
  subtext = '',
  headerText = '',
  cta,
}) => {
  const desktopMediaEntry = desktopMedia as TypeImage;
  const mobileMediaEntry = mobileMedia as TypeImage;

  return (
    <section
      data-testid={`homepage-hero-${entryName}`}
      className={styles.promoHero}
    >
      {desktopMediaEntry && (
        <Image
          alt={desktopMediaEntry?.fields?.altText}
          imageData={desktopMediaEntry}
          className="hidden md:block"
        />
      )}
      {mobileMediaEntry && (
        <Image
          alt={mobileMediaEntry?.fields?.altText}
          imageData={mobileMediaEntry}
          className="md:hidden"
        />
      )}
      <div className="max-w-[1200px] mx-auto bg-off-white">
        <div className="md:max-w-[300px] lg:max-w-[500px] xl:max-w-[615px] md:absolute md:top-1/2 transform md:-translate-y-1/2 px-5 py-6 md:text-white">
          <h1
            className="text-[32px] font-bold leading-10 md:text-[40px] md:leading-[40px] lg:text-[64px] lg:leading-[64px] xl:text-[80px] md:leading-none md:px-0 xl:leading-[80px] text-center md:text-left"
            dangerouslySetInnerHTML={{ __html: headerText }}
          />
          {subtext && (
            <h4
              className="text-lg md:text-xl lg:text-2xl xl:text-[32px] md:max-w-[700px] md:mt-3 lg:mt-5 xl:mt-7"
              dangerouslySetInnerHTML={{ __html: subtext }}
            />
          )}
          {cta && (
            <UniversalCta
              link={cta}
              defaultButtonStyle="Holiday"
              className="inline-flex mt-3 md:mt-1 lg:mt-3 xl:mt-5"
            />
          )}
        </div>
      </div>
    </section>
  );
};
